/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Bench_Sources_TitleInputs */

const en_home_bench_sources_title = /** @type {(inputs: Home_Bench_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it used`)
};

const lv_home_bench_sources_title = /** @type {(inputs: Home_Bench_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kas tika izmantots`)
};

/**
* | output |
* | --- |
* | "What it used" |
*
* @param {Home_Bench_Sources_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_bench_sources_title = /** @type {((inputs?: Home_Bench_Sources_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Bench_Sources_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_bench_sources_title(inputs)
	return en_home_bench_sources_title(inputs)
});